module.exports = __webpack_public_path__ + "static/media/F1-Redux.aa0a3376.svg";